import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd7df13e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[68px] tw-rounded-[6px]"
}
const _hoisted_3 = ["id", "data-cy", "onClick"]
const _hoisted_4 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center" }
const _hoisted_5 = { class: "tw-ml-[-5px]" }
const _hoisted_6 = ["data-id"]
const _hoisted_7 = { class: "tw-flex tw-items-center" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["data-cy", "data-show"]
const _hoisted_10 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center tw-ml-[25px] tw-gap-1" }
const _hoisted_11 = ["id", "data-cy", "onKeyup"]
const _hoisted_12 = ["data-cy"]
const _hoisted_13 = ["data-cy"]
const _hoisted_14 = { class: "tw-flex tw-items-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "card-container tw-grid tw-grid-cols-2 tw-gap-[20px]" }
const _hoisted_17 = {
  key: 0,
  class: "custom-global-skeleton tw-col-span-2 md:tw-col-span-1 tw-h-[112px] tw-rounded-[6px]"
}
const _hoisted_18 = {
  key: 1,
  class: "tw-col-span-2 xl:tw-col-span-1"
}
const _hoisted_19 = {
  key: 2,
  class: "custom-global-skeleton tw-col-span-2 md:tw-col-span-1 tw-h-[112px] tw-rounded-[6px]"
}
const _hoisted_20 = ["id", "data-cy"]
const _hoisted_21 = { class: "tw-text-[13px] tw-font-medium tw-leading-[100%]" }
const _hoisted_22 = ["id"]
const _hoisted_23 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[74.5px] tw-rounded-[6px]"
}
const _hoisted_24 = { class: "tw-w-full tw-flex" }
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "tw-text-[14px] tw-font-semibold tw-leading-[130%]" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-w-[26px] tw-h-[26px] tw-min-w-[26px] tw-min-h-[26px] tw-bg-[#387DFF] tw-rounded-[50%]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-white tw-text-base tw-font-medium tw-mt-[2px]" }, "+")
], -1))

import { PropType, Ref, computed, onMounted, ref, watch } from "vue";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import {
  IChecklistMetricsCompletion,
  IChecklistScoreDetail,
} from "@/interfaces/assessments/IAssessmentDetails";
import ArrowIcon from "../svgs/arrowIcon.vue";
import { downloadCSV, getComponentUiText } from "@/utils/utilities";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import PopoverAssessment from "../assessment/popoverAssessment.vue";
import VendorAssessmentHistory from "./vendorAssessmentHistory.vue";
import VendorProgressCard from "./vendorProgressCard.vue";
import VendorShareCard from "./vendorShareCard.vue";
import { CHECKLISTSTATUS, MODAL_NAME } from "@/utils/constants";
import { useRouter } from "vue-router";
import { IChecklistRequested, IDataEmailGrant } from "@/interfaces/vendor";
import store from "@/store";
import VendorAssessmentChecklistStatusTag from "./vendorAssessmentChecklistStatusTag.vue";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Checklist, Vendor } from "@/services/apiRoutes/routes";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { putChecklistRequested } from "@/services/vendor";
import { getAssessmentItemsCSV } from "@/services/assessment";
import dayjs from "dayjs";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import ProgressGraph from "../common/progressGraph.vue";
import { checklistRequestedStatusId } from "@/utils/constants";
import CustomDropDownItem from "../common/customDropDownItem.vue";

interface Option {
  order: number;
  id: number;
  text: string;
  arrowRed: boolean;
  statusTag: string;
  statusTagId: string;
  isShow: boolean;
  textId: (item: Option) => string;
  action: (item: any) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentDetails',
  props: {
  details: { type: Object as PropType<IChecklistRequested>, required: true },
  index: { type: Number, default: 0 },
  checklistId: { type: Number, required: true, default: 0 },
},
  emits: [
  "select:assessment",
  "loaded",
  "onRefresh",
  "update:details",
],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
const SCORE_DETAIL_DEFAULT = {
  checklistScore: 0,
  checklistScoreMax: 100,
  checklistScorePcnt: 0,
} as IChecklistScoreDetail;



const isLoading: Ref<boolean> = ref(false);
const isLoadingAPI = ref(false);
const selectAll: Ref<boolean> = ref(false);
const showContent: Ref<boolean> = ref(props.index === 0 ? true : false);
const showContentCard: Ref<boolean> = ref(props.index === 0 ? true : false);
const innerTextRestoreAssessmentBtnRef: Ref = ref(null);
const animationWidth = ref(0);
const checklistCompletion = ref({} as IChecklistMetricsCompletion);
const checklistScoreDetail: Ref<IChecklistScoreDetail> = computed(
  () => SCORE_DETAIL_DEFAULT,
);
const assessmentNameStore: Ref<string> = computed(() => {
  return "Current assessment";
});
const subMenuOptions: Ref<Option[]> = computed(() => [
  {
    order: 1,
    id: 5,
    text: "app-vendor-assessment-manage-submenu-restore-assessment-option-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: props.details.isArchived === true,
    textId: () =>
      `verdor-assessment-popover-item-restore-${props.details.checklistRequestedId}`,
    action: () => handleRestoreAssessment(),
  },
  {
    order: 2,
    id: 6,
    text:
      props.details.statusId === CHECKLISTSTATUS.DONE ||
      props.details.statusId === CHECKLISTSTATUS.CREATED
        ? "app-component-assessment-detail-dropdown-option-view-assessment-title-1"
        : "app-component-assessment-detail-review-button",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: props.details.isArchived === false,
    textId: () =>
      `verdor-assessment-popover-item-view-${props.details.checklistRequestedId}`,
    action: () => viewAssessment(),
  },
  {
    order: 3,
    id: 7,
    text: "app-component-dropdown-set-assessment-to-1",
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.SUBMITTED,
    statusTagId: CHECKLISTSTATUS.SUBMIT,
    isShow:
      props.details.isArchived === false &&
      props.details.statusId === CHECKLISTSTATUS.DONE,
    textId: () =>
      `verdor-assessment-popover-item-ready-review-${props.details.checklistRequestedId}`,
    action: () =>
      handleReadyToReviewAssessment(props.details.checklistRequestedId),
  },
  {
    order: 4,
    id: 8,
    text: "app-component-dropdown-set-assessment-to-1",
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.COMPLETED,
    statusTagId: CHECKLISTSTATUS.DONE,
    isShow:
      props.details.isArchived === false &&
      props.details.statusId !== CHECKLISTSTATUS.DONE,
    textId: () =>
      `verdor-assessment-popover-item-complete-${props.details.checklistRequestedId}`,
    action: () => handleCompleteAssessment(props.details.checklistRequestedId),
  },
  {
    order: 5,
    id: 1,
    text: "app-vendor-assessment-manage-submenu-rename-assessment-option-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: props.details.isArchived === false,
    textId: (item) =>
      `verdor-assessment-popover-item-${item.id}-${props.details.checklistRequestedId}`,
    action: () => handleRenameAssessment(),
  },
  {
    order: 6,
    id: 2,
    text: "app-vendor-assessment-manage-submenu-change-recipient-option-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: props.details.isArchived === false,
    textId: (item) =>
      `verdor-assessment-popover-item-${item.id}-${props.details.checklistRequestedId}`,
    action: (item) => handleChangeRecipientAction(item),
  },
  // {
  //   order: 7,
  //   id: 3,
  //   text: "app-vendor-assessment-manage-submenu-set-inprogress-option-1",
  //   isShow: props.details.statusId !== CHECKLISTSTATUS.INPROG,
  //   action: (item) => handleSetAssessmentInProgressAction(item),
  // },
  {
    order: 8,
    id: 4,
    text: "app-vendor-assessment-manage-submenu-download-assessment-option-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: props.details.isArchived === false,
    textId: (item) =>
      `verdor-assessment-popover-item-${item.id}-${props.details.checklistRequestedId}`,
    action: () => handleDownloadAssessment(),
  },
  {
    order: 9,
    id: 9,
    text: "app-vendor-assessment-btn-delete-assessment-1",
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    isShow: props.details.isArchived === false,
    textId: () =>
      `verdor-assessment-popover-item-delete-${props.details.checklistRequestedId}`,
    action: () => handleDeleteAssessment(),
  },
]);
const sortedSubMenuOptions = computed(() => {
  return subMenuOptions.value.slice().sort((a, b) => a.order - b.order);
});
const popoverAssessmentHeaderRef: Ref = ref(false);
const popoverAssessmentContentRef: Ref = ref(false);
const isUpdateAssessmentName: Ref<boolean> = ref(false);
const assessmentName = ref(props.details.name);
const dataEmailGrantRef = ref({} as IDataEmailGrant);
const dataEmailGrants = ref([] as IDataEmailGrant[]);
const isCallApiUpdate = ref(false);
onMounted(() => initial());

const initial = async () => {
  const checklistRequestedHistory =
    props.details.checklistRequestedHistory || [];
  if (checklistRequestedHistory?.length > 0) {
    for (const history of checklistRequestedHistory) {
      await store.dispatch("Vendor/fetchExternalRequestedEmailGrant", {
        checklistRequestedId: history.checklistRequestedId,
        emailGrantId: history.statusEmailGrantId,
        providerId: history.providerId,
      });
    }
  }
  await fetchDataEmailGrant();
};

watch(
  () => isLoading.value,
  (newVal) => {
    if (newVal === false) emit("loaded");
  },
);

const handleRefresh = () => {
  emit("onRefresh");
};

watch(
  () => props.details,
  (newVal, oldVal) => {
    assessmentName.value = newVal.name;
    if (newVal !== oldVal) {
      fetchDataEmailGrant();
    }
  },
);

const fetchDataEmailGrant = async () => {
  const dataEmailGrant = await store.dispatch(
    "Vendor/fetchChecklistRequestedEmailGrants",
    props.details.checklistRequestedId,
  );
  const index = dataEmailGrant.emailGrants.length - 1;
  // get the last email grant
  dataEmailGrantRef.value = dataEmailGrant?.emailGrants[index] || {};
  dataEmailGrants.value = dataEmailGrant?.emailGrants || [];
};

const handleDeleteAssessment = async () => {
  try {
    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: true,
      },
      checklistRequestedId: props.details.checklistRequestedId,
    });
    if (res) {
      await fetchDataEmailGrant();
      showSuccessToast(
        getComponentUiText("app-vendor-assessment-delete-assessment-success-1"),
      );
    }
    popoverAssessmentContentRef.value.popoverShow = false;
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const collapseDetails = (e: any) => {
  if (e.target.id === "non-effective") return;
  showContent.value = !showContent.value;
};

const handleSelectAll = (e: Event) => {
  e.stopPropagation();
  selectAll.value = !selectAll.value;
};

const handleSelectAssessment = () => {
  selectAll.value = !selectAll.value;
  emit("select:assessment", props.details.checklistRequestedId);
};

const viewAssessment = () => {
  router.push({
    name: "AssessmentVendorReview",
    params: { assessmentId: props.details.checklistRequestedId },
  });
};

const openModalCreateVendorAssessment = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_CREATE_NEW_VENDOR_ASSESSMENT,
    properties: {
      subTitle: getComponentUiText(
        "app-vendor-assessment-create-new-subtitle-1",
        false,
        { providerName: props.details?.providerName },
      ),
      provider: props.details,
      // providerId: props.details.providerId,
      isShowWarning: true,
    },
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleChangeRecipientAction = (item) => {
  const dataEmailGrant = item.dataEmailGrant;
  const properties = {
    checklistRequestedId: item.checklistRequestedId,
    emailGrantId: dataEmailGrant
      ? item.dataEmailGrant.emailGrantId
      : item.emailGrantId,
    providerId: item.providerId,
    offererOrgName: dataEmailGrant ? item.dataEmailGrant.orgName : "",
    recipientEmail: dataEmailGrant ? item.dataEmailGrant.recipientEmail : "",
    validFrom: dataEmailGrant ? item.dataEmailGrant.validFrom : "",
    validUntil: dataEmailGrant ? item.dataEmailGrant.validUntil : "",
    checklistRequestedName: item.name,
    dataEmailGrants: dataEmailGrants.value,
    templateId: dataEmailGrant
      ? item.dataEmailGrant.templateId
      : item.templateId,
    dataItem: item,
  };
  const emitData = {
    component: MODAL_NAME.MODAL_VENDOR_EDIT_ASSESSMENT_DETAIL,
    properties,
    events: {
      "update:data": () => fetchDataEmailGrant(),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  popoverAssessmentHeaderRef.value.popoverShow = false;
  popoverAssessmentContentRef.value.popoverShow = false;
};

const handleSetAssessmentInProgressAction = async (item) => {
  isLoadingAPI.value = true;
  const params = {
    providerId: item.providerId,
    checklistRequestedId: item.checklistRequestedId,
  };
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.INPROG };
  const optionIndex = subMenuOptions.value.findIndex(
    (option) => option.id === 3,
  );
  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
    });
    popoverAssessmentContentRef.value.popoverShow = false;
    subMenuOptions.value[optionIndex].isShow = false;
    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-inprogress-success-1",
      ),
    );
  } catch (error: any) {
    isLoadingAPI.value = false;
    subMenuOptions.value[optionIndex].isShow = true;
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

const handleRenameAssessment = async () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  isUpdateAssessmentName.value = true;
  const idName = `vendor-assessment-detail-rename-${props.details.checklistRequestedId}`;
  setTimeout(() => {
    document.getElementById(idName)?.focus();
  }, 300);
};

const onRenameAssessment = async () => {
  isUpdateAssessmentName.value = false;
  if (isCallApiUpdate.value) return;

  isCallApiUpdate.value = true;
  try {
    const res = await putChecklistRequested({
      checklistRequestedId: props.details.checklistRequestedId,
      params: {
        checklistRequestedName: assessmentName.value,
      },
    });
    const historyItem = props.details.checklistRequestedHistory?.find(
      (item) =>
        item.checklistRequestedId === props.details.checklistRequestedId,
    );
    if (historyItem) {
      historyItem.name = assessmentName.value;
    }
    if (!res) {
      assessmentName.value = props.details.name;
    }
    setTimeout(() => {
      isCallApiUpdate.value = false;
    }, 100);
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const handleDownloadAssessment = async () => {
  try {
    const res = await getAssessmentItemsCSV(props.details.checklistRequestedId);
    downloadCSV(
      res,
      `CyberSystem_Assessment_Export_${dayjs().format("YYYYMMDD_HHmmss")}_${
        assessmentName.value
      }.csv`,
    );
    if (res) {
      showSuccessToast(
        getComponentUiText(
          "app-vendor-assessment-download-assessment-success-1",
        ),
      );
    }
    popoverAssessmentContentRef.value.popoverShow = false;
  } catch (error) {
    showErrorAPI(error, Checklist.getAssessmentItemsCSV);
  }
};

const handleRestoreAssessment = async () => {
  if (isLoadingAPI.value) return;
  isLoadingAPI.value = true;
  if (innerTextRestoreAssessmentBtnRef.value) {
    animationWidth.value =
      innerTextRestoreAssessmentBtnRef.value.getBoundingClientRect()[
        "width"
      ] as number;
  }
  try {
    popoverAssessmentContentRef.value.popoverShow = false;

    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: false,
      },
      checklistRequestedId: props.details.checklistRequestedId,
    });

    if (!res) {
      isLoadingAPI.value = false;
      return;
    }

    showSuccessToast(
      getComponentUiText("app-vendor-assessment-restore-assessment-success-1"),
    );
  } catch (error) {
    isLoadingAPI.value = false;
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const listProvider = computed(() => {
  return store.state.Vendor.listProvider;
});

const handleEditVendor = () => {
  const result = listProvider.value.find(
    (item) => item.id === props.details.providerId,
  );

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_MANAGE_VENDOR_DETAIL,
    properties: {
      data: {
        id: result?.id,
        name: result?.name,
        description: result?.description,
        url: result?.url,
        phone: result?.phone,
        urlSupport: result?.urlSupport,
        phoneSupport: result?.phoneSupport,
        notes: result?.notes,
      },
    },
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleCompleteAssessment = async (checklistRequestedId) => {
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.DONE };
  const params = {
    checklistRequestedId,
  };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-complete-success-1",
      ),
    );

    popoverAssessmentContentRef.value.popoverShow = false;
    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: false,
    });
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

const handleReadyToReviewAssessment = async (checklistRequestedId) => {
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.SUBMIT };
  const params = { checklistRequestedId };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-ready-review-success-1",
      ),
    );

    popoverAssessmentContentRef.value.popoverShow = false;
    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: false,
    });
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `vendor-assessment-detail-${__props.details.checklistRequestedId}`,
    class: "tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-rounded-[6px] tw-font-[Poppins]"
  }, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: `vendor-assessment-detail-collapse-${props.details.checklistRequestedId}`,
          class: _normalizeClass(` tw-flex-wrap tw-cursor-pointer tw-h-[68px] tw-select-none tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-[1px] tw-border-b-[1px] tw-border-solid tw-border-[#EFF0F1] ${
        showContent.value ? 'tw-rounded-t-[6px]' : 'tw-rounded-[6px]'
      }`),
          "data-cy": `vendor-assessment-detail-collapse-${props.details.checklistRequestedId}`,
          onClick: _withModifiers(collapseDetails, ["self"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "tw-py-[20px]",
              onClick: handleSelectAll
            }, [
              _createVNode(CustomCheckBox, {
                "is-checked": selectAll.value,
                "onUpdate:isChecked": [
                  _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
                  handleSelectAssessment
                ],
                class: "tw-h-[20px] tw-ml-[25px] !tw-mb-0",
                size: "20px"
              }, null, 8, ["is-checked"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                class: "tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]",
                "data-cy": "vendor-name",
                "data-id": `${props.details.checklistRequestedId}`
              }, _toDisplayString(__props.details?.providerName), 9, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(PopoverAssessment, {
              ref_key: "popoverAssessmentHeaderRef",
              ref: popoverAssessmentHeaderRef,
              class: "tw-h-[56px]",
              offset: 0,
              "id-popover": `popover-vender-assessment-${__props.index}`,
              "style-button": "tw-w-[61px] tw-items-center tw-justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(CustomDropDownItem, {
                  "id-text": 'app-modal-manage-vendor-edit-vendor-title-1',
                  "custom-text-class": 'tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] tw-whitespace-normal',
                  "arrow-icon-style": 'tw-text-[#387DFF] tw-min-w-[7px]',
                  padding: 'tw-px-[13px] tw-py-[12px]',
                  "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                  onClick: handleEditVendor
                })
              ]),
              _: 1
            }, 8, ["id-popover"]),
            _createElementVNode("span", {
              class: "float-right tw-p-[10px] tw-ml-[-10px] tw-mr-[-10px]",
              onClick: collapseDetails
            }, [
              _createVNode(ArrowIcon, {
                class: _normalizeClass(['right-arrow tw-mr-[2px]', showContent.value ? 'show-all' : '']),
                "data-cy": `vendor-assessment-details-collapse-arrow-${props.details.checklistRequestedId}`,
                width: 6,
                height: 9
              }, null, 8, ["class", "data-cy"])
            ])
          ])
        ], 10, _hoisted_3)),
    _createElementVNode("div", {
      class: _normalizeClass([
        'content tw-flex tw-flex-col tw-gap-[20px] tw-bg-[#FFFFFF] tw-rounded-b-[6px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]',
        showContent.value
          ? 'show tw-h-auto tw-py-[25px] tw-px-[20px] tw-border-[1px] tw-border-t-0'
          : '',
      ])
    }, [
      _createElementVNode("div", {
        id: `vendor-assess-manage-current-detail-${__props.details.checklistRequestedId}`,
        class: "card-container tw-flex tw-flex-col"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(` tw-flex-wrap tw-cursor-pointer tw-select-none tw-h-[68px] tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-[1px] tw-border-b-[1px] tw-border-solid tw-border-[#EFF0F1] ${
            showContentCard.value ? 'tw-rounded-t-[6px]' : 'tw-rounded-[6px]'
          }`),
          "data-cy": `vendor-assess-manage-current-detail-${__props.details.checklistRequestedId}`,
          "data-show": `${showContentCard.value ? 'true' : 'false'}`,
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showContentCard.value = !showContentCard.value), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_10, [
            (isUpdateAssessmentName.value)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: `vendor-assessment-detail-rename-${props.details.checklistRequestedId}`,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((assessmentName).value = $event)),
                  type: "text",
                  class: "tw-rounded-md tw-w-[200px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-py-[5px] tw-px-[10px] tw-text-[15px] tw-font-[400] tw-text-[#211F58] tw-mr-2",
                  "data-cy": `current-assessment-name-input-${__props.details.checklistRequestedId}`,
                  onKeyup: _withKeys(onRenameAssessment, ["enter"]),
                  onBlur: onRenameAssessment
                }, null, 40, _hoisted_11)), [
                  [_vModelText, assessmentName.value]
                ])
              : _createCommentVNode("", true),
            (!isUpdateAssessmentName.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]",
                  "data-cy": `current-assessment-name-${__props.details.checklistRequestedId}`
                }, _toDisplayString(assessmentName.value) + " - ", 9, _hoisted_12))
              : _createCommentVNode("", true),
            (__props.details.dateAdded)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "tw-font-Poppins tw-text-[18px] tw-font-[400] tw-text-[#211F58]",
                  "data-cy": `current-assessment-created-date-${__props.details.checklistRequestedId}`
                }, _toDisplayString(_unref(convertUTCTimeToLocalTime)(__props.details.dateAdded)), 9, _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(VendorAssessmentChecklistStatusTag, {
              "is-archived": __props.details.isArchived,
              "checklist-status": __props.details.status,
              "checklist-status-id": __props.details.statusId,
              "is-loading": false,
              "checklist-requested-id": __props.details.checklistRequestedId.toString()
            }, null, 8, ["is-archived", "checklist-status", "checklist-status-id", "checklist-requested-id"]),
            _createVNode(PopoverAssessment, {
              ref_key: "popoverAssessmentContentRef",
              ref: popoverAssessmentContentRef,
              class: "tw-h-[56px]",
              offset: 0,
              "id-popover": `popover-verdor-assessment-card-${__props.details.checklistRequestedId}`,
              "style-button": "tw-w-[61px] tw-items-center tw-justify-center",
              "b-popover": "popover-has-tag"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSubMenuOptions.value, (item) => {
                  return (_openBlock(), _createBlock(CustomDropDownItem, {
                    id: item.textId(item),
                    key: `option_vendor_assessment_detail_${item.id}`,
                    "is-show-option": item.isShow,
                    "id-text": `${item.text}`,
                    "custom-text-class": `tw-flex tw-items-center tw-gap-[5px] tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                  item.arrowRed ? 'tw-text-[#F7553C]' : ''
                } tw-whitespace-normal`,
                    "arrow-icon-style": `${
                  item.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
                } tw-min-w-[7px]`,
                    padding: 'tw-px-[13px] tw-py-[12px]',
                    "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                    "tag-is-archived": __props.details.isArchived,
                    "tag-status": item.statusTag,
                    "tag-status-id": item.statusTagId,
                    onClick: ($event: any) => (item.action(__props.details))
                  }, null, 8, ["id", "is-show-option", "id-text", "custom-text-class", "arrow-icon-style", "tag-is-archived", "tag-status", "tag-status-id", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["id-popover"]),
            _createElementVNode("span", {
              class: "float-right tw-p-[10px] tw-ml-[-10px] tw-mr-[-10px]",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showContentCard.value = !showContentCard.value))
            }, [
              _createVNode(ArrowIcon, {
                class: _normalizeClass([
                  'right-arrow tw-mr-[2px]',
                  showContentCard.value ? 'show-all' : '',
                ]),
                width: 6,
                height: 9
              }, null, 8, ["class"])
            ])
          ])
        ], 10, _hoisted_9),
        _createElementVNode("div", {
          class: _normalizeClass([
            'card-container-wrapper tw-flex tw-gap-[20px] tw-flex-col tw-rounded-b-[6px] tw-border-0',
            showContentCard.value
              ? 'show tw-h-auto tw-py-[25px] tw-px-[20px] tw-border-[1px] tw-border-t-0'
              : '',
          ])
        }, [
          (
              __props.details.statusId === _unref(checklistRequestedStatusId).created ||
              __props.details.statusId === _unref(checklistRequestedStatusId).inProgress ||
              __props.details.statusId === _unref(checklistRequestedStatusId).submitted ||
              __props.details.statusId === _unref(checklistRequestedStatusId).completed ||
              __props.details.statusId === _unref(checklistRequestedStatusId).waiting
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(ProgressGraph, { details: __props.details }, null, 8, ["details"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(VendorProgressCard, {
                    class: _normalizeClass(['card-content']),
                    "class-style-content": '!tw-bg-[#FCFCFD]',
                    "class-style-icon": '!tw-bg-[#FCFCFD]',
                    detail: __props.details,
                    "status-detail": __props.details,
                    "checklist-completion-props": checklistCompletion.value,
                    "checklist-score-detail": checklistScoreDetail.value,
                    "is-assessment-detail": true
                  }, null, 8, ["detail", "status-detail", "checklist-completion-props", "checklist-score-detail"])
                ])),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
              : (_openBlock(), _createBlock(VendorShareCard, {
                  key: 3,
                  class: "tw-col-span-2 xl:tw-col-span-1",
                  detail: __props.details,
                  "data-email-grant": dataEmailGrantRef.value
                }, null, 8, ["detail", "data-email-grant"]))
          ]),
          (!__props.details.isArchived)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                id: `vender-view-assessment-btn-${__props.details.checklistRequestedId}`,
                "data-cy": `view-assessment-btn-${__props.details.checklistRequestedId}`,
                class: "tw-border-[1.5px] tw-border-solid tw-border-[#387DFF] tw-leading-[100%] tw-text-white tw-bg-[#387DFF] tw-rounded-[100px] tw-flex tw-items-center tw-self-end tw-px-[20px] tw-py-[8px] tw-h-[36px]",
                onClick: viewAssessment
              }, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(__props.details.statusId === _unref(CHECKLISTSTATUS).CREATED ||
              __props.details.statusId === _unref(CHECKLISTSTATUS).DONE
                ? _unref(getComponentUiText)(
                    "app-component-assessment-detail-dropdown-option-view-assessment-title-1",
                  )
                : _unref(getComponentUiText)(
                    "app-component-assessment-detail-review-button",
                  )), 1)
              ], 8, _hoisted_20))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                id: `vendor-view-assessment-btn-${__props.details.checklistRequestedId}`,
                class: "tw-border-[1.5px] tw-border-solid tw-border-[#387DFF] tw-leading-[100%] tw-text-white tw-bg-[#387DFF] tw-rounded-[100px] tw-flex tw-items-center tw-self-end tw-px-[20px] tw-py-[8px] tw-h-[36px]",
                onClick: handleRestoreAssessment
              }, [
                (!isLoadingAPI.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      ref_key: "innerTextRestoreAssessmentBtnRef",
                      ref: innerTextRestoreAssessmentBtnRef,
                      class: "tw-text-[13px] tw-font-medium tw-leading-[100%]"
                    }, _toDisplayString(_unref(getComponentUiText)(
                  "app-vendor-assessment-manage-submenu-restore-assessment-option-1",
                )), 513))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      style: _normalizeStyle({ width: animationWidth.value + 'px' }),
                      class: "tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
                    }, [
                      _createVNode(_unref(LottieAnimation), {
                        ref: "anim",
                        "animation-data": _unref(ProgressAnimation),
                        "auto-play": true,
                        loop: true
                      }, null, 8, ["animation-data"])
                    ], 4))
              ], 8, _hoisted_22))
        ], 2)
      ], 8, _hoisted_8),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23))
        : (_openBlock(), _createBlock(VendorAssessmentHistory, {
            key: 1,
            id: `vendor-assess-manage-history-${__props.details.checklistRequestedId}`,
            assessments: __props.details.checklistRequestedHistory,
            "assessment-name": assessmentNameStore.value,
            "checklist-id": __props.checklistId,
            "checklist-requested-id": __props.details.checklistRequestedId,
            onOnRefresh: handleRefresh,
            onOnChangeRecipient: _cache[4] || (_cache[4] = (item) => handleChangeRecipientAction(item)),
            onOnSetInprogress: _cache[5] || (_cache[5] = (item) => handleSetAssessmentInProgressAction(item)),
            onOnDeleteAssessment: fetchDataEmailGrant
          }, null, 8, ["id", "assessments", "assessment-name", "checklist-id", "checklist-requested-id"])),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          id: `vendor-create-assessment-btn-${__props.details.checklistRequestedId}`,
          class: "tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-flex tw-items-center tw-justify-between tw-w-full tw-leading-[130%] tw-text-[#211F58] tw-bg-white tw-rounded-md tw-px-[25px] tw-py-[15px] tw-h-[58px]",
          onClick: openModalCreateVendorAssessment
        }, [
          _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(getComponentUiText)(
              "app-assessment-assessment-vendor-button-send-assessment-title-1",
            )), 1),
          _hoisted_27
        ], 8, _hoisted_25)
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})